module.exports = __webpack_public_path__ + "static/media/FiltersGroup.39257cf7.svg";